import React from 'react'
// import { Link } from 'gatsby'
import cn from 'classnames'

import { Link } from '../transition'
import ArrowRight from '~/assets/svg/p-arrow-right.svg'

import s from './styles.module.scss'

type Props = {
  label: string
  href: string
  color?: 'white' | 'black'
  disabled?: boolean
}

const BorderButton: React.FC<Props> = ({
  label,
  href,
  color = 'white',
  disabled,
}) => {
  return (
    <Link
      className={cn(s.border, { [s[`color_${color}`]]: true })}
      to={href}
      disabled={disabled}
    >
      <span>{label}</span>
      <div className={s.svg}>
        <ArrowRight />
      </div>
    </Link>
  )
}

export default BorderButton
